import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'esc-entrynum-guide-dialog',
  templateUrl: './entrynum-guide-dialog.component.html',
  styleUrls: ['./entrynum-guide-dialog.component.scss']
})
export class EntrynumGuideDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EntrynumGuideDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

}
